import type * as Types from '../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CurrentUserPointsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CurrentUserPointsQuery = { __typename?: 'RootQueryType', currentUser?: { __typename?: 'User', id: string, pointsEarned: number } | null };


export const CurrentUserPointsDocument = gql`
    query CurrentUserPoints {
  currentUser {
    id
    pointsEarned
  }
}
    `;

/**
 * __useCurrentUserPointsQuery__
 *
 * To run a query within a React component, call `useCurrentUserPointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserPointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserPointsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserPointsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserPointsQuery, CurrentUserPointsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserPointsQuery, CurrentUserPointsQueryVariables>(CurrentUserPointsDocument, options);
      }
export function useCurrentUserPointsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserPointsQuery, CurrentUserPointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserPointsQuery, CurrentUserPointsQueryVariables>(CurrentUserPointsDocument, options);
        }
// @ts-ignore
export function useCurrentUserPointsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentUserPointsQuery, CurrentUserPointsQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentUserPointsQuery, CurrentUserPointsQueryVariables>;
export function useCurrentUserPointsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserPointsQuery, CurrentUserPointsQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentUserPointsQuery | undefined, CurrentUserPointsQueryVariables>;
export function useCurrentUserPointsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserPointsQuery, CurrentUserPointsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserPointsQuery, CurrentUserPointsQueryVariables>(CurrentUserPointsDocument, options);
        }
export type CurrentUserPointsQueryHookResult = ReturnType<typeof useCurrentUserPointsQuery>;
export type CurrentUserPointsLazyQueryHookResult = ReturnType<typeof useCurrentUserPointsLazyQuery>;
export type CurrentUserPointsSuspenseQueryHookResult = ReturnType<typeof useCurrentUserPointsSuspenseQuery>;
export type CurrentUserPointsQueryResult = Apollo.QueryResult<CurrentUserPointsQuery, CurrentUserPointsQueryVariables>;